import i18n from "@/i18n"
import { Nullable } from "primevue/ts-helpers"

const { t } = i18n.global

export const baseTiposDeValores = {
  INTEIRO: "numero_inteiro",
  DECIMAL: "numero_decimal",
  IDENTIFICACAO: "codigo_identificador",
  TEXTO: "texto",
  OPCAO: "opcao",
  DATA: "data",
  HORA: "horario",
  LISTA: "itens_de_lista",
  QUANTIDADE_INTEIRA: "quantidade_inteira",
  QUANTIDADE_DECIMAL: "quantidade_decimal",
  QUANTIDADE_DE_HORAS: "quantidade_de_horas",
} as const

const naturezaAtributo = {
  CARACTERISTICA: "caracteristica",
  CAPACIDADE: "capacidade",
} as const

const periodosConsumo = {
  AO_MESMO_TEMPO: "aoMesmoTempo",
  NA_MESMA_ATIVIDADE: "naMesmaAtividade",
  NO_MESMO_DIA: "noMesmoDia",
  NA_MESMA_SEMANA: "naMesmaSemana",
  NO_MESMO_MES: "noMesmoMes",
} as const

type B = typeof baseTiposDeValores
type N = typeof naturezaAtributo
type P = typeof periodosConsumo

export type NaturezaAtributo = N[keyof N]
export type PeriodosDeConsumo = {
  [key in P[keyof P]]?: boolean | Nullable<number>
}
export type TiposPossiveis = B[keyof B]

type TipoDeValor =
  | "numero_inteiro"
  | "numero_decimal"
  | "codigo_identificador"
  | "texto"
  | "opcao"
  | "itens_de_lista"
  | "horario"
  | "data"
  | "quantidade_inteira"
  | "quantidade_decimal"
  | "quantidade_de_horas";

export const mapTipoDeValor: { [key in TipoDeValor]: string } = {
  "numero_inteiro": t("atributos.numeroInteiro"),
  "numero_decimal": t("atributos.numeroDecimal"),
  "codigo_identificador": t("atributos.codigoIdentificador"),
  "texto": t("atributos.texto"),
  "opcao": t("atributos.opcao"),
  "itens_de_lista": t("atributos.itensDeLista"),
  "horario": t("atributos.horario"),
  "data": t("atributos.data"),
  "quantidade_inteira": t("atributos.quantidadeInteira"),
  "quantidade_decimal": t("atributos.quantidadeDecimal"),
  "quantidade_de_horas": t("atributos.quantidadeDeHoras"),
}

export enum ColunasAtributos {
  NOME = "nome",
  NATUREZA = "natureza",
  TIPO_DE_VALOR = "tipoDeValor",
  VALORES_POSSIVEIS = "valoresPossiveis",
  ACOES = "acoes",
}
